<app-dialog [title]="('term.public-link' | translate)">

  <div class="content" appDialogContent>
    @if (!link) {
      <div class="public-link-description">Сгенерируйте ссылку для общего доступа к выбранным объектам на карте.
        Она будет активна в выбранный вами период и позволит другим людям просматривать их местоположение без входа в
        систему.
      </div>
    }
    <div matTooltipClass="big-multiline-tooltip"
         [matTooltip]="selectedUnitNames"
         class="text-primary-color">
      <b>Выбрано объектов: {{ selectedUnitsCount }}</b>
    </div>

    @if (!link) {
      <div class="date-picker-content">
        <app-date-time-picker selectionMode="range" viewMode="double" footerAlignment="center"
          [selected]="period.selection"
          [fixedStartDate]="period.startDay"
          [minDate]="period.minimum"
          (validChange)="periodValid = $event"
          (selectedChange)="changeDateTimeRange($event)" />
      </div>
    } @else {
      <div class="box-link">
        <div class="link">
          <mat-form-field>
            <mat-label>{{ 'term.link' | translate }}</mat-label>
            <input matInput
                   [value]="link"
                   readonly/>
          </mat-form-field>
        </div>

        <div class="message">
          {{
            'message.info.anyone-can-view-location' | translate:
              {time: expirationInZone((authUser$ | async)?.timeZone.name) | zonedDateTimeFormat: 'dd.MM.yyyy HH:mm'}
          }}
        </div>
      </div>
    }
  </div>

  <ng-container appDialogActions>
    @if (!link) {
      <app-button-cancel (action)="onClose()">
      </app-button-cancel>

      <app-button-primary [text]="'action.generate' | translate"
                          [disabled]="!!link || !periodValid"
                          (action)="onGenerateLink()">
      </app-button-primary>
    } @else {
      <app-button-close></app-button-close>
      <app-button-primary [text]="'Скопировать ссылку'"
                          (action)="copyToClipboard()">
      </app-button-primary>
    }

  </ng-container>

</app-dialog>
